export const USAGE_DATA = 'usageData';
export const WEB_SDK_TESTS = 'webSdkTests';
export const WFA_SESSIONS = 'wfaSessions';
export const WFA_SESSION_SUMMARY = 'wfaSessionSummary';
export const WEB_SDK_TEST_LABELS = 'webSdkTestLabels';
export const WEB_SDK_TEST_DETAILS = 'webSdkTestDetails';
export const WEB_SDK_ISSUES_FILTER_OPTIONS = 'webSdkIssuesFilterOptions';
export const WEB_SDK_ISSUES = 'webSdkIssues';
export const WEB_SDK_TEST_BASE_DATA = 'webSdkTestBaseData';
export const PROPERTIES = 'properties';

export const WFA_USAGE_DATA = 'wfaUsageData';
export const WFA_SESSION_DETAILS = 'wfaSessionDetails';
export const WFA_SESSION_NAME = 'wfaSessionName';
export const WFA_SESSION_ALL_ISSUES = 'wfaSessionAllIssues';
export const WFA_SESSION_COMPONENTS = 'wfaSessionComponents';
export const WFA_SESSION_TOP_COMPONENTS = 'wfaSessionTopComponents';
export const WFA_SESSION_SEVERITIES = 'wfaSessionSeverities';
export const WFA_SESSION_TYPES_BREAKDOWN = 'wfaSessionTypesBreakdown';
export const WFA_SESSION_FILTER_OPTIONS = 'wfaSessionFilterOptions';
export const WFA_COMPONENT_SAMPLE_ISSUE = 'wfaComponentSampleIssue';
export const WFA_USER_OPTIONS = 'wfaUserOptions';

// MFA
export const MFA_SESSIONS = 'mfaSessions';
export const MFA_SUMMARY_DATA = 'mfaSummaryData';
export const MFA_OWNER_OPTIONS = 'mfaOwnerOptions';
export const MFA_LABELS_OPTIONS = 'mfaLabelsOptions';
export const MFA_SESSION_DETAILS = 'mfaSessionDetails';
export const MFA_SESSION_ALL_ISSUES = 'mfaSessionAllIssues';
export const MFA_SESSION_FILTER_OPTIONS = 'mfaSessionFilterOptions';
export const MFA_SESSION_SCANS = 'mfaSessionScans';
export const MFA_SESSION_SEVERITIES = 'mfaSessionSeverities';
export const MFA_SESSION_SUMMARY = 'mfaSessionSummary';
export const MFA_SESSION_ISSUE_TYPES = 'mfaSessionIssueTypes';
export const MFA_ISSUE_DETAILS = 'mfaIssueDetails';
export const MFA_ISSUE = 'mfaIssue';
/** @public */
export const MOBILE_SCANS_LIST = 'mobileScansList';

// Mobile SDK
export const MOBILE_SDK_TESTS = 'mobileSdkTests';
export const MOBILE_SDK_TESTS_FILTER_OPTIONS = 'mobileSdkTestsFilterOptions';
export const MOBILE_SDK_SUMMARY_DATA = 'mobileSdkSummaryData';
export const MOBILE_SDK_TEST_DETAILS = 'mobileSdkTestDetails';
export const MOBILE_SDK_TEST_ALL_ISSUES = 'mobileSdkTestAllIssues';
export const MOBILE_SDK_TEST_FILTER_OPTIONS = 'mobileSdkTestFilterOptions';
export const MOBILE_SDK_TEST_SUMMARY = 'mobileSdkTestSummary';
export const MOBILE_SDK_ISSUE_DETAILS = 'mobileSdkIssueDetails';
export const MOBILE_SDK_ISSUE = 'mobileSdkIssue';
export const MOBILE_SDK_TEST_ISSUE_TYPES = 'mobileSdkTestIssueTypes';
export const MOBILE_SDK_TEST_SEVERITIES = 'mobileSdkTestSeverities';

// common
export const PLATFORM_ISSUE_DETAILS = 'platformIssueDetails';

// Dashboard
export const DASHBOARD_DATA = 'dashboardData';
export const DASHBOARD_WEB_SDK_TESTS = 'dashboardWebSdkTests';
export const DASHBOARD_WFA_SESSIONS = 'dashboardWfaSessions';
export const DASHBOARD_BUSINESS_UNITS_TABLE = 'dashboardBusinessUnitsTable';
export const DASHBOARD_SCORE_DATA = 'dashboardScoreData';
export const DASHBOARD_UNIQUE_ISSUES = 'dashboardUniqueIssues';
export const DASHBOARD_ALL_ISSUES = 'dashboardAllIssues';
export const DASHBOARD_MOBILE_DATA = 'dashboardMobileData';
export const DASHBOARD_MOBILE_SCORE_DATA = 'dashboardMobileScoreData';
export const DASHBOARD_MOBILE_BUSINESS_UNITS_TABLE = 'dashboardMobileBusinessUnitsTable';
export const DASHBOARD_MFA_SESSIONS = 'dashboardMfaSessions';
export const DASHBOARD_MOBILE_SDK_TESTS = 'dashboardMobileSdkTests';
export const DASHBOARD_MOBILE_UNIQUE_ISSUES = 'dashboardMobileUniqueIssues';
export const DASHBOARD_MOBILE_ALL_ISSUES = 'dashboardMobileAllIssues';
